const styles = () => ({
	lcName: {
		textDecoration: "none",
	},
});

export default styles;
